import { create } from "zustand";
import { createJSONStorage, persist } from 'zustand/middleware';

const usePreviewZoom = create(
    persist((set) => ({
        previewZoom: 0,
        /**
         * @param {number} zoom 
         */
        changePreviewZoom: (zoom) => set({ previewZoom: zoom })
    }), {
        name: 'previewZoom',
        storage: createJSONStorage(() => sessionStorage)
    })
);

export default usePreviewZoom;
